$ = require 'jquery'
Auth = require 'db/auth'
ModelLoader = require 'db/model-loader'
Payloads = require 'network/payloads'
{ maybeDisplayCardLimitsError } = require 'views/card/card-limits-error'
LabelLimitsErrorView = require 'views/label/label-limits-error-view'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
template = require 'views/templates/popover_move_list'
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class ListMoveView extends View
  viewTitleKey: 'move list'

  tagName: 'form'

  events:
    'change .js-select-list-pos': 'renderValues'
    'change .js-select-board': 'updateBoardData'
    'click .js-commit-position': 'commitChange'
    'submit': 'commitChange'

  render: ->
    view = @
    model = view.model

    data =
      organizations: Auth.me().getOpenBoardsByOrg(true)

    for org in data.organizations
      for board in org.boards
        if board.id == model.get('idBoard')
          board.selected = true

    @$el.html(
      template(data)
    )

    @updateBoardData()

    @

  renderValues: ->
    $el = $(@el)

    idBoard = $el.find('.js-select-board option:selected').val()
    index = parseInt($el.find('.js-select-list-pos option:selected').text(), 10)

    board = @modelCache.get('Board', idBoard)
    boardName = board.get('name')

    $el.find('.js-board-value').text boardName
    $el.find('.js-pos-value').text String(index)

    return

  updateBoardData: ->
    $el = $(@el)
    $selectBoard = $el.find('.js-select-board')
    idBoardSelected = $selectBoard.find('option:selected').val()

    if idBoardSelected == @model.getBoard().id
      @_boardData = @model.getBoard()
      for list in @_boardData.listList.models
        list.cardCount = @_boardData.listList.get(list.id).openCards().length
      @updateListList()
    else
      $otherSelects = $el.find('.select-list,.select-position')
      $otherSelects.attr('disabled', 'disabled')
      ModelLoader.loadBoardData idBoardSelected, Payloads.listsMinimal
      .then =>
        @_boardData = @modelCache.get('Board', idBoardSelected)
        @updateListList()
        $otherSelects.removeAttr('disabled')
      .done()
    return

  updateListList: ->
    view = @
    model = view.model

    $selectList = @$('.js-select-list-pos')
    $selectList.empty()

    openLists = @_boardData.listList.models
    isCurrentBoard = @_boardData.id == @model.getBoard().id

    if isCurrentBoard
      currentIndex = _.indexOf openLists, @model
      count = openLists.length
    else
      currentIndex = -1
      count = openLists.length + 1

    for i in [0...count]
      indexString = String(i + 1)
      desc = if i == currentIndex
        l('current position', { index: indexString })
      else
        indexString

      pos = @_boardData.listList.calcPos(i, model)
      $option = $('<option>').val(pos).text(desc).appendTo($selectList)
      if i == currentIndex
        $option.attr('selected', 'selected')

    $commitButton = @$('.js-commit-position')
    $limitExceededError = @$('.js-list-limit-exceeded')
    if !isCurrentBoard
      tooManyLists = @_boardData.isOverLimit('lists', 'totalPerBoard') ||
        @_boardData.isOverLimit('lists', 'openPerBoard')
      $commitButton
        .toggleClass('disabled', tooManyLists)
        .prop('disabled', tooManyLists)
      $limitExceededError.toggleClass('hide', !tooManyLists)
    else
      $commitButton
        .toggleClass('disabled', false)
        .prop('disabled', false)
      $limitExceededError.toggleClass('hide', true)

    @renderValues()

  commitChange: (e) ->
    Util.stop(e)

    $selectListPos = @$('.js-select-list-pos')
    listPosSelected = parseInt($selectListPos.find('option:selected').val(), 10)
    idBoardSelected = @$('.js-select-board option:selected').val()

    @model.getBoard().composer.save("vis", false)

    if idBoardSelected == @model.getBoard().id
      @model.update({ pos: listPosSelected })
      track("List Menu", "Move Menu", "Successfully Moved")
    else if idBoardSelected? && listPosSelected?
      if @model.cardList.length > 0 && maybeDisplayCardLimitsError(e, @_boardData, null)
        return
      hasLabels = @model.cardList.filter (c) ->
        c.getLabels().length > 0
      if hasLabels && @_boardData.isOverLimit('labels', 'perBoard')
        PopOver.pushView(new LabelLimitsErrorView())
        return

      @model.update({ idBoard: idBoardSelected, pos: listPosSelected })
      track("List Menu", "Move Menu", "Changed Board")

    PopOver.hide()
    return



// WEBPACK FOOTER //
// ./app/scripts/views/list/list-move-view.coffee